<template lang="html">
  <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</template>

<script>
export default {
}
</script>
